import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Ticketview } from './ticketview';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Comment } from '../comment/comment';
import { UpdateTicket } from './updateticket';
import { DatePipe } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class TicketviewService {
    constructor(private http: HttpClient,
        private datePipe: DatePipe) {

    }
    ticketviewurl = environment.graphURL;
    ticketsurl = environment.appURL + "/tickets";
    commenturl = environment.appURL + "/comments";

    getTickets() {
        return this.http.get < Ticketview[] > (this.ticketsurl, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) })
            .pipe(
                tap(_ => {}),
                catchError(this.handleError('getTickets', []))
            );
    }

    getTicketview(id: number) {
        const url = `${this.ticketsurl}/${id}`;
        return this.http.get < Ticketview > (url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) })
            .pipe(
                tap(_ => {}),
                catchError(this.handleError < Ticketview > (`getTicket id=${id}`))
            );
    }



    getTicketviewGraphQl(id: number) 
    {
        const url = this.ticketviewurl + "{ticket(id:\"" + id + "\"){ id user{username firstname lastname img}  dispatchorder{id} observer{username firstname lastname} id dateofticket dateresolved errorcode resolution assigned_to{id username firstname lastname} machines{id shortname serialnumber state{statevalue} counter machinetype{type} client{id name} imageurl location{addr1 City Country contact_name phone_number email  }} title details status{id status} comments {id user{username avatar{url} firstname lastname img} postedon content} attachment{url}  attachments{id refId data name size mime user{firstname username}}}}";
        return this.http.get(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) })
            .pipe(map(data => data['data']['ticket']));
    }


    private handleError < T > (operation = 'operation', result ? : T) {
        return (error: any): Observable < T > => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            console.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    uploadFile(file: any) 
    {
        return this.http.post(environment.appURL + "/uploads", file, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) })
            .pipe(
                tap(_ => {}),
                catchError(this.handleError < any > ('updateStatus'))
            );
    }

    createNewComment(comment: Comment): Observable < any > 
    {
        let upd = "content=" + comment.content + "&user=" + comment.user + "&ticket=" + comment.ticket
        return this.http.post(this.commenturl + "/", upd, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/x-www-form-urlencoded" }) })
            .pipe(
                tap(_ => {}),
                catchError(this.handleError < any > ('updateStatus'))
            );
    }

    deleteComment(comment: Comment): Observable < any > {
        let options = {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + environment.token,
                "Content-Type": "application/x-www-form-urlencoded"
            }),
            body: comment,
        };
        const urld = this.commenturl + "/" + comment.id;
        return this.http.delete < Comment > (urld, options);
    }


    changeState(ticketID: number, statusID: number, details: string, resolution: string, assignedToId: number) 
    {
        var updates = new UpdateTicket;
        updates.status = statusID;
        updates.details = details;
        updates.resolution = resolution;
        updates.assigned_to = assignedToId;
        
        var timestamp = new Date();
        this.datePipe.transform(timestamp, "yyy-MM-dd");
        updates.dateresolved = timestamp;
        var urlcommand = this.ticketsurl + "/" + ticketID;
        return this.http.put(urlcommand, JSON.stringify(updates), { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) });
    }


}